// extracted by mini-css-extract-plugin
module.exports = {"tab":"mantineTabs_tab__pM1xc","list":"mantineTabs_list__ksYsx","root":"mantineTabs_root___PcEY","panel":"mantineTabs_panel__Sj_8N"};